import React from "react";
import { EmbedModuleView } from "@amzn/awt-module-views-react-17";
import { Alert } from "@amzn/awsui-components-react";
import {
  MODULE_ID as AGENT_MODULE_ID,
  viewTypes,
  STAGES,
} from "@amzn/loom-agent-assistance-widget-api";
import { LoomAgentAssistantLoadingState } from "./LoomAgentAssistantLoadingState";
import { isProdStage } from "../../util/stageUtils";

export const LoomAgentAssistantWidget: React.FC = () => {
  return (
    <div
      data-testid="loom-agent-assistant-widget"
      style={{ width: "100%", height: "100%", overflow: "auto" }}
    >
      <EmbedModuleView
        viewTypeDefinition={viewTypes.loomAgentAssistanceWidget}
        providerModuleId={AGENT_MODULE_ID}
        viewProps={{
          stage: isProdStage() ? STAGES.PROD : STAGES.BETA,
          // endpoint: '', // Override stage prop
        }}
        renderFailed={(error) => {
          console.error("[Agent Widget] Failed to render:", error);
          return (
            <Alert data-testid="agent-widget-error" type="error">
              The widget failed to load. Check console for details.
            </Alert>
          );
        }}
        renderWaiting={() => {
          return <LoomAgentAssistantLoadingState />;
        }}
      />
    </div>
  );
};

export default LoomAgentAssistantWidget;
